import { render, staticRenderFns } from "./TypeTaskSelect.vue?vue&type=template&id=37bf45d3&"
import script from "./TypeTaskSelect.vue?vue&type=script&lang=js&"
export * from "./TypeTaskSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports